import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M16.25 7.917h-.625V5.625a5.625 5.625 0 00-11.25 0v2.292H3.75a1.667 1.667 0 00-1.667 1.666v8.75A1.666 1.666 0 003.75 20h12.5a1.667 1.667 0 001.666-1.667v-8.75a1.667 1.667 0 00-1.666-1.666zm-6.25 7.5a1.667 1.667 0 110-3.334 1.667 1.667 0 010 3.334zM13.54 7.5a.417.417 0 01-.416.417h-6.25a.417.417 0 01-.417-.417V5.625a3.542 3.542 0 117.083 0V7.5z",
      fill: "#22a4f5"
    }
  )
), o = t;
export {
  o as default
};
